import { BrowserStorage } from '@estee/elc-universal-utils';
import { VTO_SURVEY_STORAGE_KEY } from '../constants/Survey';
import { ELCLogger, TriggerType } from '@estee/elc-logging';

const { name: serviceName, version: serviceVersion } = __serviceInfo__;

export const getVtoSurveyStorage = (vtoType?: string) => {
    const storage = BrowserStorage.getItem(VTO_SURVEY_STORAGE_KEY);
    let surveyStorage;
    const logger = new ELCLogger({ serviceName, serviceVersion });

    if (storage) {
        try {
            surveyStorage = JSON.parse(storage);

            return vtoType ? surveyStorage[vtoType] : surveyStorage;
        } catch (error) {
            logger.warning({
                triggerType: TriggerType.api,
                payload: { error },
                message: `${error.message}`
            });
        }
    }
};
